import { render } from "./filter.vue?vue&type=template&id=32a2eafd&scoped=true"
import script from "./filter.vue?vue&type=script&lang=js"
export * from "./filter.vue?vue&type=script&lang=js"

import "./filter.vue?vue&type=style&index=0&id=32a2eafd&scoped=true&lang=css"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a2eafd"]])

export default __exports__